webpackJsonp([15400075347947],{

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _theme = __webpack_require__(6);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _PageDetailContainer = __webpack_require__(46);
	
	var _PageDetailContainer2 = _interopRequireDefault(_PageDetailContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsPage = function (_React$Component) {
	    _inherits(TermsPage, _React$Component);
	
	    function TermsPage() {
	        _classCallCheck(this, TermsPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    TermsPage.prototype.componentDidMount = function componentDidMount() {
	        setTimeout(function () {
	            window.dispatchEvent(new Event("load"));
	        }, 0);
	    };
	
	    TermsPage.prototype.render = function render() {
	        var transition = this.props.transition;
	
	        return _react2.default.createElement(
	            "div",
	            { style: transition && transition.style },
	            _react2.default.createElement(
	                _PageDetailContainer2.default,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement(
	                            _HeaderBlock2.default,
	                            {
	                                textAlign: "left",
	                                baseColor: _theme.colors.background,
	                                fontSize: 3,
	                                padding: {
	                                    top: 0.6,
	                                    right: 0,
	                                    bottom: 2.4,
	                                    left: 0
	                                }
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                "Privacy "
	                            ),
	                            "Policy"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "RLA Group Ltd is committed to protecting your privacy"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "This Cookie and Privacy Policy applies to RLA Group Ltd (\u201CRLA Group Ltd\u201D, \u201Cwe\u201D, or \u201Cus\u201D) owned and operated websites and subdomains (\u201Csites\u201D)"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "This policy sets out the basis on which any personal data we collect by us, or that you provide to us, will be processed by us, how the information is used, and how you can control the collection, correction and/or deletion of information. Please read the following carefully to understand our views and practices regarding your personal data and how we will treat it."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "No personal data will be shared with anyone except as described in this Policy"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "For the purposes of this policy, the data controller is RLA Group Ltd, Parley Green Lane, Christchurch, Dorset BH23 6BB."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "1. Information we collect"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(a) Our Service(s): We may collect personal identifiable information about you, such as name, address, phone number, email address or anything similar. We do not send any promotional emails, however we may send you information relating to services we can provide/offer you. You may opt out of receiving these emails at any time."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(b) Cookies and Tracking: Some technologies may be used by RLA Group Ltd on our sites such as cookies, marketing and analytics. These technologies may be used to analyse certain trends within our sites, gather information around page visits and /or demographic information, and to ensure the site performs in the best possible way. We may generate reports based on the results from the information gathered.",
	                            _react2.default.createElement("br", null),
	                            "We use cookies to remember users on some of our sites, user authentication and/or analytics. Users have the ability to control the use of cookies on our sites. If cookies are disabled, you may still use our sites but may have limited functionality.",
	                            _react2.default.createElement("br", null),
	                            "This website uses Google Analytics to track user activity across the website. To learn more about Google Analytics, please visit http://www.google.com/intl/en_uk/analytics/privacyoverview.html If you wish to disable Google analytics you may do so by disabling tracking cookies on the sites."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(c) Log Information: A log is automatically generated by our servers when someone browsers to our sites and all subsequent visits to the sites. An IP address is stored against a time stamp within these logs. There is no other personal data relating to you or your system stored in these logs"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(d) Access and Retention of Collected Data: Anyone who has signed up to receive information from any of our sites may correct, amend or request deletion of any stored data by directing their query to privacy@rla.co.uk",
	                            _react2.default.createElement("br", null),
	                            "If we receive any request for the above we will respond within 72 business hours"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Personal data will be retained for as long as required to provide our services, comply with legal obligations and /or resolve disputes"
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "2. How we use your data"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The information we collect from our sites is used to provide marketing information on products and services offered by us, respond to any questions/queries and help improve our sites"
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "3. How we share your information"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(a) Personal Data: RLA Group Ltd will not rent or sell any personal data provided by you to anyone else. We may store personal data on systems outside of our direct control (hosting providers, databases, email service providers)."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(b) Non-Personal Data: We may share non personal data with third parties such as anonymous usage data, page clicks etc). This is to help us provide a better service and build on any further services we may offer in the future."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "(c) Sharing your information: Your information will only be disclosed where required to do so by law. We will restrict any information provided where possible."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "4. Storage and Processing"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Information collected by our sites will be stored within the EU. We may transfer information supplied by you, including personal information, to our affiliated entities."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "5. How we protect your information"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Our main priority is to protect your privacy and data but we are unable to warrant the security of any third parties your data is passed on to. We have industry standard security practices in place to help protect your data but cannot guarantee the data may not be accessed, disclosed, altered or deleted due to a breach of these safeguards. All information accessed over our sites are encrypted using SSL (Secure Socket Layer) technology, although no method of transfer or encryption can be 100% secure we do implement best practices.",
	                            _react2.default.createElement("br", null),
	                            "If you have any concerns or questions about the security of our sites, please contact privacy@rla.co.uk."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "6. Data breaches"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "In the event of a compromise in personal data any affected data subject will be promptly notified in compliance with EU law."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "7. Links to external websites and services"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "We are not responsible for the security standards used by any websites/services out of our control that are linked to or from our sites. Any external site linked to or from ours will have their own Cookie and Privacy Policy, our policies will not apply."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "8. Changes to our Cookie and Privacy Policy"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "All changes made to our policies are effective as soon as they are posted on our sites. Any major changes to our policies will be communicated via email if required. Our latest policy will always be available on our sites."
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Cookies"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Cookies are very small text files that are stored on your computer when you visit some websites.",
	                            _react2.default.createElement("br", null),
	                            " use cookies to make our website easier for you to use. You disable certain cookies on our site but this may impact the performance of the sites we provide."
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TermsPage;
	}(_react2.default.Component);
	
	exports.default = TermsPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-4236adf30ee20917eb76.js